import { useEffect, useState } from "react";
import STATES from '../constants/STATES.json';
import { fetchLocation, fetchZipCode } from "../fetch/fetch";
const useIpZipCode = () => {
    const [ipZipCode, setIpZipCode] = useState("");
    const [isFetching, setIsFetching] = useState(false);
    useEffect(() => {

        getData();

    }, [])


    const getData = () => {
        setIsFetching(true);
        // get ip location
        const storedZipcode = localStorage.getItem('constellationZipcode');

        if (storedZipcode) {
            setIpZipCode(storedZipcode);
            setIsFetching(false);
        }
        else {
            fetchLocation().then(res => {
                if (res && res.response) {
                    const { city, state } = res.response || {};
                    let zipCode = ""
                    const stateCode = STATES.find((st) => st.name === state)?.code!;
                    fetchZipCode(city, stateCode).then(addrResponse => {
                        if (addrResponse) {
                            const addObj = addrResponse.find((addr: any) => addr.city === city && addr.state === stateCode);
                            if (addObj) {
                                zipCode = addObj.zipcode
                                setIpZipCode(zipCode);
                                localStorage.setItem('constellationZipcode', zipCode);
                                setIsFetching(false);
                            } else {
                                setIpZipCode("");
                                setIsFetching(false);
                            }
                        } else {
                            setIpZipCode("");
                            setIsFetching(false);
                        }
                    })

                } else {
                    setIpZipCode("");
                    setIsFetching(false);
                }
            })

        }
    }

    return { ipZipCode, isFetching };
}


export default useIpZipCode;